import { IsArray } from 'class-validator';

export class SupplierSettingsDto {
  @IsArray()
  documentsCC: string[] = [];
}
